<template>
  <b-card class="mrp-calculator">
    <template #header>
      <div class="header">
        <span>Revised MRP Calculator</span>
        <button
          class="reset-btn"
          @click="reset"
        >
          <feather-icon
            size="14"
            icon="RotateCwIcon"
            color="white"
          />
        </button>
      </div>
    </template>

    <b-card-body>
      <div class="input-section">
        <input
          v-model.number="oldMrp"
          type="number"
          step="0.01"
          placeholder="Old MRP (Incl. GST)"
          @keyup.enter="calculate"
        >

        <div class="row-inputs">
          <input
            v-model.number="oldGstRate"
            type="number"
            step="0.01"
            placeholder="Old GST %"
            @keyup.enter="calculate"
          >
          <input
            v-model.number="newGstRate"
            type="number"
            step="0.01"
            placeholder="New GST %"
            @keyup.enter="calculate"
          >
        </div>

        <button
          class="calc-btn"
          @click="calculate"
        >
          <feather-icon
            size="14"
            icon="CalculatorIcon"
          />
          Calculate
        </button>
      </div>

      <div
        v-if="results.calculated"
        class="results"
      >
        <div class="row">
          <span>New Base Price:</span>
          <span>₹ {{ results.newBasePrice }}</span>
        </div>
        <div class="row">
          <span>New GST (@ {{ newGstRate }}%):</span>
          <span>₹ {{ results.newGst }}</span>
        </div>
        <div class="row final">
          <span>New Revised MRP:</span>
          <span>₹ {{ results.newRevisedMrp }}</span>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody } from 'bootstrap-vue'

export default {
  name: 'MRPCalculator',
  components: { BCard, BCardBody },
  data() {
    return {
      oldMrp: null,
      oldGstRate: null,
      newGstRate: null,
      results: {
        calculated: false,
        newBasePrice: '0.00',
        newGst: '0.00',
        newRevisedMrp: '0.00',
      },
    }
  },
  methods: {
    calculate() {
      if (this.oldMrp && this.oldGstRate !== null && this.newGstRate !== null) {
        const basePrice = this.oldMrp / (1 + this.oldGstRate / 100)
        const newGstAmount = basePrice * (this.newGstRate / 100)
        const newMrp = basePrice + newGstAmount

        this.results = {
          calculated: true,
          newBasePrice: basePrice.toFixed(2),
          newGst: newGstAmount.toFixed(2),
          newRevisedMrp: newMrp.toFixed(2),
        }
      }
    },
    reset() {
      this.oldMrp = null
      this.oldGstRate = null
      this.newGstRate = null
      this.results = {
        calculated: false,
        newBasePrice: '0.00',
        newGst: '0.00',
        newRevisedMrp: '0.00',
      }
    },
  },
}
</script>

<style scoped>
.mrp-calculator {
  max-width: 400px;
  margin: 0 auto;
}

/* Header */
.mrp-calculator >>> .card-header {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  color: white;
  padding: 4px 12px;
  width: 100%;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.header span {
  font-size: 0.85rem;
  font-weight: 600;
}

.reset-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s;
}

.reset-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Body */
.mrp-calculator >>> .card-body {
  padding: 0;
}

/* Input Section */
.input-section {
  padding: 12px;
}

.input-section input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.85rem;
  margin-bottom: 8px;
}

.row-inputs {
  display: flex;
  gap: 8px;
}

.row-inputs input {
  flex: 1;
}

.calc-btn {
  width: 100%;
  padding: 8px;
  margin-top: 0;
  background: linear-gradient(135deg, #28a745 0%, #218838 100%);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

/* Results */
.results {
  background: #f8f9fa;
  padding: 12px;
  border-top: 1px solid #ddd;
}

.results .row {
  display: flex;
  justify-content: space-between;
  padding: 6px 10px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 6px;
  font-size: 0.8rem;
}

.results .row span:first-child {
  color: #666;
}

.results .row span:last-child {
  color: #333;
  font-weight: 600;
}

.results .row.final {
  border: 2px solid #333;
  font-weight: 700;
}

.results .row.final span {
  font-size: 0.85rem;
}
</style>
